module.exports = __webpack_public_path__ + "static/media/mastercard.04291e59.png";